<div id="lang-switch" [class]="theme">
    <p (click)="setLang('de')" [class]="{'active': checkCurrentLang('de')}">DE</p>
    <p (click)="setLang('en')" [class]="{'active': checkCurrentLang('en')}">EN</p>
</div>